import { Box, Icon, type LargeIcon, Text } from '@factorialco/deprecated-design-system'

type Props = {
  text: string
  icon: LargeIcon
}

const Headline = ({ icon, text }: Props) => {
  return (
    <Box gap="s16" alignItems="center">
      <Box
        background="grey200"
        alignItems="center"
        justifyContent="center"
        borderRadius={{ all: 'rel333' }}
        padding="s16"
      >
        <Icon.Large icon={icon} color="radicalRed1000" />
      </Box>
      <Text size="500" weight="medium" color="grey1000">
        {text}
      </Text>
    </Box>
  )
}

export default Headline
